var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) scale(1.22) translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79053 4.78061C9.78177 3.85547 11.3296 3.88866 12.2798 4.85581C13.1833 5.77574 13.2309 7.21891 12.4253 8.19565C11.6393 7.33571 10.1928 7.43639 9.55908 8.4896L9.5581 8.49155L7.7583 11.4925L7.75732 11.4935C7.61725 11.7275 7.53781 11.9736 7.51025 12.2181L3.72119 8.35971C2.76621 7.38705 2.76602 5.82835 3.72119 4.85581C4.6714 3.88845 6.22011 3.85539 7.21142 4.78061L8.00049 5.51694L8.79053 4.78061Z",
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7911 8.93194C10.9309 8.69907 11.2684 8.69916 11.4083 8.93194L13.5684 12.5325C13.7123 12.7725 13.5387 13.0784 13.2589 13.0784H8.94051C8.66074 13.0784 8.48802 12.7725 8.63191 12.5325L10.7911 8.93194ZM11.0977 11.72C10.9655 11.7203 10.8586 11.8247 10.8585 11.9534C10.8585 12.0823 10.9654 12.1866 11.0977 12.1868C11.2303 12.1868 11.338 12.0824 11.338 11.9534C11.3379 11.8245 11.2302 11.72 11.0977 11.72ZM11.0987 10.0853C10.9051 10.0853 10.7531 10.2508 10.7696 10.4437L10.838 11.2474C10.8496 11.3826 10.963 11.4866 11.0987 11.4866C11.2344 11.4866 11.3479 11.3826 11.3595 11.2474L11.4278 10.4437C11.4443 10.2508 11.2923 10.0853 11.0987 10.0853Z",
    fill: "#002A69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCondition);
export default __webpack_public_path__ + "static/media/Health_condition.7b99d500a2e01d4c65c79ce67cd4bb0e.svg";
export { ForwardRef as ReactComponent };